import { TrackerA } from "@/components/Tracker";
import { useMount } from "ahooks";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import updateLocale from "dayjs/plugin/updateLocale";
import { useMemo, useRef } from "react";
import { Else, If, Then, When } from "react-if";
import styles from "./card.module.less";
enum DateType {
  singleDay = 0, //单日
  manyDays,
}
dayjs.extend(updateLocale);
dayjs.extend(isBetween);
dayjs.updateLocale("en", {
  weekdays: ["周天", "周一", "周二", "周三", "周四", "周五", "周六"],
});
export default function Card(props) {
  const { festivalInfo, festival, clickCard, autoScroll } = props;
  const isElementInAnotherElementViewport = (elementA, elementB) => {
    const {
      top: topA,
      bottom: bottomA,
      left: leftA,
      right: rightA,
    } = elementA.getBoundingClientRect();
    const {
      top: topB,
      bottom: bottomB,
      left: leftB,
      right: rightB,
    } = elementB.getBoundingClientRect();

    return (
      topA >= topB && bottomA <= bottomB && leftA >= leftB && rightA <= rightB
    );
  };

  const cardRef = useRef(null);
  const festivalTime = useMemo(() => {
    const { date_type, festival_time, festival_end_time } = festivalInfo;
    if (date_type === DateType.singleDay) {
      return dayjs(festival_end_time).format("MM.DD dddd");
    } else {
      return `${dayjs(festival_time).format("MM.DD")} - ${dayjs(
        festival_end_time
      ).format("MM.DD")}`;
    }
  }, [festivalInfo]);
  useMount(() => {
    if (
      autoScroll &&
      festivalInfo.code === festival &&
      !isElementInAnotherElementViewport(
        cardRef.current,
        document.querySelector(".wrapper") ||
          document.querySelector("#layout-content")
      )
    ) {
      setTimeout(() => {
        cardRef.current.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }, 10);
    }
  });

  const remainingDays = useMemo(() => {
    const { festival_time } = festivalInfo;
    return dayjs(festival_time).diff(dayjs().format("YYYY-MM-DD"), "day");
  }, [festivalInfo]);
  const chooseCard = (e) => {
    e.preventDefault();
    clickCard && clickCard(festivalInfo, festival);
  };

  return (
    <TrackerA
      ref={cardRef}
      href={`/calendars/${festivalInfo.code}`}
      onClick={chooseCard}
      className={`${styles.content} ${
        festival === festivalInfo.code && styles.active
      }`}
      data-gd-click="button_click"
      data-button-name={`${festivalInfo.title}`}
    >
      <When condition={festivalInfo.top_priority}>
        <div className={styles.hot}>热</div>
      </When>
      <div className={styles.left}>
        <div
          className={styles.title}
          id={
            festival === festivalInfo.code && styles.active
              ? "active-filter-one"
              : null
          }
        >
          {festivalInfo.title}
        </div>
        <div className={styles.time}>{festivalTime}</div>
      </div>
      <div className={styles.right}>
        {/* 当开始时间等于今天，或者当节日为多日时候，在时间区间内 */}
        <If
          condition={
            remainingDays === 0 ||
            (festivalInfo.date_type === DateType.manyDays &&
              dayjs()
                // .format("YYYY-MM-DD")
                .isBetween(
                  festivalInfo.festival_time,
                  festivalInfo.festival_end_time,
                  "day",
                  "[]"
                ))
          }
        >
          <Then>
            <div className={styles.title}>今天</div>
          </Then>
          <Else>
            <If condition={remainingDays > 0}>
              <Then>
                <div>
                  <span className={styles.remainingDaysLeft}>
                    {remainingDays}
                  </span>
                  <span className={styles.remainingDaysRight}>天后</span>
                </div>
              </Then>
            </If>
          </Else>
        </If>
      </div>
    </TrackerA>
  );
}
